






import { OrderStatusViewModel } from '@spa/components/organisms/mypage/order/model/order-status-view'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class DefaultStatusView extends Vue {
  @Prop({ required: true })
  readonly statusView: OrderStatusViewModel
}
